<template>
  <div class="map-elem-info none"></div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
</style>
